import { useMutation, useQueryClient } from '@tanstack/react-query';

import { contactListsKeys } from '#contactListFeature/models/keys';

import {
	createCustomColumn,
	deleteCustomColumn,
	exportContactListCsv,
	previewCustomColumn,
	setCustomCellValue,
	startColumnFill,
	updateCustomColumn,
} from '../api/customColumnsApi';

import { customColumnKeys, customColumnMutationKeys } from './keys';

// Column definitions change what every list row shows (formula values are computed on read).
const invalidateColumnsAndRows = (queryClient) => {
	queryClient.invalidateQueries({ queryKey: customColumnKeys.all });
	queryClient.invalidateQueries({ queryKey: contactListsKeys.all });
};

export function useCreateCustomColumn() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: customColumnMutationKeys.create,
		mutationFn: createCustomColumn,
		onSuccess: () => invalidateColumnsAndRows(queryClient),
	});
}

export function useUpdateCustomColumn() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: customColumnMutationKeys.update,
		mutationFn: updateCustomColumn,
		onSuccess: () => invalidateColumnsAndRows(queryClient),
	});
}

export function useDeleteCustomColumn() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: customColumnMutationKeys.delete,
		mutationFn: deleteCustomColumn,
		onSuccess: () => invalidateColumnsAndRows(queryClient),
	});
}

export function usePreviewCustomColumn() {
	return useMutation({ mutationKey: customColumnMutationKeys.preview, mutationFn: previewCustomColumn });
}

export function useStartColumnFill() {
	return useMutation({ mutationKey: customColumnMutationKeys.fill, mutationFn: startColumnFill });
}

export function useSetCustomCellValue() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: customColumnMutationKeys.setValue,
		mutationFn: setCustomCellValue,
		onSuccess: () => queryClient.invalidateQueries({ queryKey: contactListsKeys.all }),
	});
}

export function useExportContactListCsv() {
	return useMutation({
		mutationKey: customColumnMutationKeys.exportList,
		mutationFn: ({ listId, ...body }) => exportContactListCsv(listId, body),
	});
}
